import { Camera } from "expo-camera";

const hasPermission = async () => {
  const { status } = await Camera.requestPermissionsAsync();
  return status === "granted";
};

export default hasPermission;
